import { render, staticRenderFns } from "./iconfont.vue?vue&type=template&id=44a5034d&"
import script from "./iconfont.vue?vue&type=script&lang=js&"
export * from "./iconfont.vue?vue&type=script&lang=js&"
import style0 from "./iconfont.vue?vue&type=style&index=0&id=44a5034d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports